"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * [[SignalingClientVideoSubscriptionConfiguration]] is an internal representation of
 * `SignalingProtocol.VideoSubscriptionConfiguration`
 */
class SignalingClientVideoSubscriptionConfiguration {
}
exports.default = SignalingClientVideoSubscriptionConfiguration;
